type Options = {
  /** `true` focuses the target; an element focuses that element instead. */
  focus?: boolean | HTMLElement | null;
  block?: "start" | "center" | "end" | "nearest";
  highlight?: boolean;
};

const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

/** Re-adds `cls` across a forced reflow so its CSS animation restarts. */
export function replayClass(el: HTMLElement, cls: string): void {
  el.classList.remove(cls);
  el.getBoundingClientRect();
  el.classList.add(cls);
}

export function scrollToAnchor(
  target: HTMLElement | null | undefined,
  { focus = false, block = "start", highlight = true }: Options = {},
): void {
  if (!target) return;
  target.scrollIntoView?.({
    behavior: prefersReducedMotion() ? "auto" : "smooth",
    block,
  });
  if (highlight) replayClass(target, "motion-highlight");
  const focusEl = focus === true ? target : focus || null;
  if (!focusEl) return;
  if (focusEl.tabIndex < 0 && !focusEl.hasAttribute("tabindex")) {
    focusEl.setAttribute("tabindex", "-1");
  }
  focusEl.focus({ preventScroll: true });
}
